import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ViewCompconfsComponent } from './composants/view-compconfs/view-compconfs.component';
import { InsertCompconfFileComponent } from './composants/insert-compconf-file/insert-compconf-file.component';

const routes: Routes = [
  { path: 'view-compconfs', component: ViewCompconfsComponent,
    
},
{ path: 'insert-compconf', component: InsertCompconfFileComponent,
    
},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionRoutingModule { }
